// extracted by mini-css-extract-plugin
module.exports = {"container":"journalHomeBlock_container__1zQEs"};